const API_BASE_URL = 'https://dev.videoanalysis-be.gihonline.in';

export const analyzeVideo = async (formData) => {
  console.log('=== ANALYZE VIDEO REQUEST ===');
  
  // Log FormData contents (for debugging)
  console.log('=== FORMDATA CONTENTS ===');
  for (let pair of formData.entries()) {
    if (pair[1] instanceof Blob) {
      console.log(pair[0] + ':', {
        type: pair[1].type,
        size: pair[1].size,
        name: pair[1].name
      });
    } else {
      console.log(pair[0] + ':', pair[1]);
    }
  }
  
  // Verify the video file
  const videoFile = formData.get('file');
  if (!videoFile || !(videoFile instanceof Blob)) {
    throw new Error('No valid video file provided');
  }
  
  if (videoFile.size === 0) {
    throw new Error('Video file is empty (0 bytes)');
  }
  
  // Verify exercise type
  const exerciseType = formData.get('exercise_type');
  if (!exerciseType) {
    throw new Error('No exercise type provided');
  }
  
  console.log('Video file details:', {
    name: videoFile.name,
    size: videoFile.size,
    type: videoFile.type
  });
  console.log('Exercise type:', exerciseType);
  
  console.log('Sending request to backend...');
  
  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 120000); // 120 second timeout
    
    console.log('Sending request to:', `${API_BASE_URL}/analyze-video/`);
    
    const response = await fetch(`${API_BASE_URL}/analyze-video/`, {
      method: 'POST',
      body: formData,
      signal: controller.signal,
      headers: {
        'Accept': 'application/json',
        // Don't set Content-Type, let the browser set it with the correct boundary
      },
    });
    
    clearTimeout(timeoutId);
    
    console.log('=== ANALYSIS RESPONSE ===');
    console.log('Status:', response.status);
    console.log('Status text:', response.statusText);
    console.log('Headers:', Object.fromEntries([...response.headers.entries()]));
    
    // Clone the response to read it twice if needed
    const responseClone = response.clone();
    
    if (!response.ok) {
      let errorText;
      try {
        const errorData = await response.json();
        console.error('Server responded with error:', errorData);
        const error = new Error(errorData.detail || `Request failed with status ${response.status}`);
        error.response = response;
        error.data = errorData;
        throw error;
      } catch (e) {
        errorText = await responseClone.text();
        console.error('Failed to parse error response:', errorText);
        const error = new Error(`Request failed with status ${response.status}: ${errorText}`);
        error.response = responseClone;
        error.text = errorText;
        throw error;
      }
    }

    try {
      const data = await response.json();
      console.log('Analysis successful:', data);
      return data;
    } catch (e) {
      console.error('Failed to parse response as JSON');
      const text = await response.text();
      console.error('Response text:', text);
      const error = new Error('Invalid response format from server');
      error.responseText = text;
      throw error;
    }
  } catch (error) {
    console.error('=== API REQUEST ERROR ===');
    console.error('Error name:', error.name);
    console.error('Error message:', error.message);
    
    if (error.name === 'AbortError') {
      throw new Error('Request timed out. Please try again.');
    }
    
    // Re-throw the error with a more user-friendly message
    if (error.message.includes('Failed to fetch')) {
      throw new Error('Could not connect to the server. Please check your connection.');
    }
    
    throw error;
  }
};

export const getExerciseTypes = async () => {
  const response = await fetch(`${API_BASE_URL}/exercise-types/`);
  
  if (!response.ok) {
    throw new Error('Failed to fetch exercise types');
  }

  return response.json();
};
